import urls from "../../constants/urls.js";
import axios from "axios";

import router from "@/router";

const state = {
  teams: [],
  loadingTeam: true,
  loadingChildrenTeam: true,
  teamsCount: null,
  totalTeams: 0,
  bulkEventPageTeams: [],
};

const generateBulkMutations = (stateField) => {
  return {
    [`check_${stateField}`](state, data) {
      state[stateField].push(data);
    },
    [`uncheck_${stateField}`](state, id) {
      if (id) {
        state[stateField] = state[stateField].filter((v) => id !== v.id);
      } else {
        state[stateField] = [];
      }
    },
  };
};

const mutations = {
  setTeams(state, data) {
    state.teams = data;
  },

  setLoadingTeam(state, value) {
    state.loadingTeam = value;
  },

  loadingChildrenTeam(state, value) {
    state.loadingChildrenTeam = value;
  },

  setTeamsCount(state, value) {
    state.teamsCount = value;
  },

  setTotalTeams(state, value) {
    state.totalTeams = value;
  },

  ...generateBulkMutations("bulkEventPageTeams"),
};

const actions = {
  getTeams({ commit }, props) {
    let orgId = localStorage.getItem("orgId");
    axios
      .get(
        urls.apiTeams
          .replace(":orgId", orgId)
          .replace(":campaignId", router.currentRoute.params.id) + props
      )
      .then((response) => {
        let team = response.data.data;
        commit("setTeamsCount", Number(response.headers["x-search-teams"]));
        commit("setTotalTeams", Number(response.headers["x-total-teams"]));
        commit("setTeams", team);
        commit("setLoadingTeam", false);
      })
      .catch((e) => {
        console.log(e);
      });
  },

  // Refreshes only the shared "does this campaign have visible teams" counter
  // (state.teams.totalTeams), scoped to hidden=false, without touching the
  // paginated teams list/count slots. Used by screens that gate a UI element
  // on "totalTeams > 0" but don't themselves need a team list.
  fetchVisibleTeamsCount({ commit }, campaignId) {
    const orgId = localStorage.getItem("orgId");

    if (Number(campaignId) === 0) {
      throw new Error("fetchVisibleTeamsCount campaign id is 0");
    }

    return axios
      .get(urls.apiTeams.replace(":orgId", orgId).replace(":campaignId", campaignId), {
        params: { hidden: false, limit: 1, page: 1 },
      })
      .then(({ headers }) => {
        const totalTeams = Number(headers["x-total-teams"]) || 0;
        commit("setTotalTeams", totalTeams);

        return totalTeams;
      });
  },

  getTeamsByCampaignId({ commit }, [id, params]) {
    const orgId = localStorage.getItem("orgId");

    commit("setLoadingTeam", true);

    if (Number(id) === 0) {
      throw new Error("getTeamsByCampaignId campaign id is 0");
    }

    const q = { limit: 50, page: 1, ...(params || {}) };
    q.limit = Math.min(Number(q.limit) || 50, 100);

    return axios
      .get(urls.apiTeams.replace(":orgId", orgId).replace(":campaignId", id), {
        params: q,
      })
      .then(({ data, headers }) => {
        commit("setTeamsCount", Number(headers["x-search-teams"]));
        commit("setTotalTeams", Number(headers["x-total-teams"]));
        commit("setTeams", data.data);
        commit("setLoadingTeam", false);

        return data.data;
      });
  },
  getTeamsByParentId({ commit }, [id, params]) {
    const orgId = localStorage.getItem("orgId");
    commit("loadingChildrenTeam", true);
    if (Number(id) === 0) {
      throw new Error("getTeamsByParentId campaign id is 0");
    }

    const q = { limit: 50, page: 1, ...(params || {}) };
    q.limit = Math.min(Number(q.limit) || 50, 100);

    return axios
      .get(urls.apiTeams.replace(":orgId", orgId).replace(":campaignId", id), {
        params: q,
      })
      .then(({ data, headers }) => {
        return {
          data: data.data,
          count: Number(headers["x-search-teams"]),
          total: Number(headers["x-total-teams"]),
        };
      })
      .finally(() => {
        commit("loadingChildrenTeam", false);
      });
  },
};

export default {
  state,
  actions,
  mutations,
};
